/* ==========================================================================
   Primal Viking · Scrolling Reviews Section
   --------------------------------------------------------------------------
   Equalizes review card heights across BOTH marquee rows. The rows are
   independent scroll tracks, so CSS alone can only equalize cards within
   one row — here we measure every card's natural height and apply the
   tallest as a shared height via the --pv-srv-card-h custom property
   (consumed in pv-scrolling-reviews.css).
   ========================================================================== */
(function () {
  'use strict';

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, wait);
    };
  }

  function initSection(section) {
    if (!section || section.dataset.pvSrvInit) return;
    section.dataset.pvSrvInit = 'true';

    var cards = section.querySelectorAll('.pv-scroll-rv__card');
    if (!cards.length) return;

    function equalize() {
      /* Clear the shared height so cards report their natural size. */
      section.style.removeProperty('--pv-srv-card-h');
      var max = 0;
      cards.forEach(function (card) {
        /* Hidden rows (other breakpoint) report 0 and are ignored. */
        max = Math.max(max, card.offsetHeight);
      });
      if (max > 0) {
        section.style.setProperty('--pv-srv-card-h', max + 'px');
      }
    }

    equalize();
    window.addEventListener('resize', debounce(equalize, 150));
    window.addEventListener('load', equalize);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(equalize);
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('.pv-scroll-rv').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  /* Theme editor: re-init when the section is re-rendered. */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
